module.exports = __webpack_public_path__ + "img/Philippines.a444f937.gif";